import { IColumnSettings } from '../entities/IClusters';
import { IPLEGridSettings } from '../entities/ILegalEntities';

const createColumn = (field: string, headerText: string): IColumnSettings => ({
    field,
    headerText,
    isVisible: true,
    width: 200,
    exportable: true
});

/**
 * Public legal entity datagrid settings captured from the profiles API.
 * Former column groups are stored as individual columns to render one header row.
 */
export const PLE_DATAGRID_SETTINGS: IPLEGridSettings = {
    datagridName: 'PLE Datagrid',
    datagridKey: 'PublicLegalEntityDatagridKey',
    userId: '',
    id: '',
    columnsSettings: [
        createColumn('entityName', 'Entity name'),
        createColumn('entityType', 'Type of entity'),
        createColumn('legalForm', 'Legal Form'),
        createColumn('nationality', 'Nationality'),
        createColumn('group', 'Group'),
        createColumn('street', 'Address'),
        createColumn('postCode', 'Post code'),
        createColumn('city', 'City'),
        createColumn('country', 'Country'),
        createColumn('registredCapital', 'Registred capital'),
        createColumn('website', 'Website'),
        createColumn('phoneNumber', 'Phone number'),
        createColumn('v.a.t', 'V.A.T'),
        createColumn('sagecode', 'SAGECODE'),
        createColumn('siret', 'SIRET'),
        createColumn('rcs', 'RCS'),
        createColumn('siren', 'SIREN'),
        createColumn('naf', 'NAF'),
        createColumn('niccode', 'NICCODE'),
        createColumn('svcode', 'SVCODE'),
        createColumn('businessname', 'BUSINESSNAME'),
        createColumn('description', 'Description'),
        createColumn('personInCharge', 'Person in charge'),
        createColumn('contactName', 'Contact name'),
        createColumn('information', 'Information'),
        createColumn('createdAt', 'Created'),
        createColumn('id', 'Technical Id'),
        createColumn('tradingName', 'TRADINGNAME'),
        createColumn('activityType', 'ACTIVITYTYPE'),
        createColumn('sectorOfActivity', 'SECTOROFACTIVITY'),
        createColumn('isListedCompany', 'ISLISTEDCOMPANY'),
        createColumn('dateOfCreation', 'DATEOFCREATION'),
        createColumn('expirationDate', 'EXPIRATIONDATE'),
        createColumn('thirdReferentials', 'Referential 3'),
        createColumn('secondReferentials', 'Geographical areas'),
        createColumn('firstReferentials', 'Branches')
    ]
};
